import styled, { css } from "styled-components";

type InfoTextContainerProps = {
  isLarge: boolean;
};

export const InfoTextContainer = styled.div<InfoTextContainerProps>`
  margin-bottom: 0.9rem;

  &.skeleton {
    width: 100%;
  }

  svg {
    path {
      stroke: var(--grey-100);
    }
  }

  > div {
    display: flex;
    flex-direction: row;

    &.body {
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25px;
        height: 25px;
        background-color: var(--black-300);
        padding: 0.3rem;
        border-radius: 4px;
        margin-right: 0.7rem;
      }

      &.skeleton {
        span {
          width: 100%;
        }
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  p {
    font-family: Inter;
    font-size: 13px;
    color: #b8b8b8;

    margin-bottom: 4px;
  }

  &.skeleton {
    > span {
      width: 100%;
    }
  }

  span {
    font-family: Inter, sans-serif;
    font-weight: 400;
    color: var(--white);
    font-size: 14px;
  }

  .iconed-text {
    > span {
      margin-top: 0.2rem;
    }
  }

  ${({ isLarge }) =>
    isLarge &&
    css`
      span {
        font-size: 20px;
        font-weight: 500;
      }
    `}
`;

export const ColumnHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.skeleton {
    span {
      width: 100%;
    }
  }

  span {
    font-size: 13px;
    font-family: DM Sans;

    margin-left: 0.6rem;
    color: var(--grey-100);
  }

  svg {
    path {
      stroke: var(--primary);
    }
  }

  .column-header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    padding: 0.45rem;
    background-color: var(--black-100);
  }
`;

export const SkeletonWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 350px;
  background: var(--black-200);
  border-radius: 4px;
  padding: 1.5rem;
  margin: 1rem 0rem;

  .container {
    display: flex;
    flex-direction: row;
    height: 100%;
  }

  .footer {
  }

  .statusTape {
    background: var(--primary);
    width: 10px;
    height: 302px;
    border-radius: 1rem;
  }

  .lateStatusTape {
    background: rgb(177, 18, 18);
    height: 302px;
    width: 10px;
    border-radius: 1rem;
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    border-right: 1px solid rgba(82, 82, 82, 0.32);
    padding: 0px 24px;
    flex: 1;

    &:last-child {
      flex: none;
      border-right: 0;
      width: 250px;
      align-items: unset;
      padding-right: 0px;
    }

    article {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      width: 100%;

      margin-top: 1.5rem;

      padding-bottom: 1.5rem;
    }

    &.skeleton {
      > div {
        width: 100%;
      }
    }
  }

  .customerBeneficiary {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 24px 0 24px;
    height: 100%;
    flex: 1;

    article {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        font-size: 14px;
        color: #b8b8b8;
      }

      h3 {
        font-size: 16px;
        color: #ebebeb;
        text-overflow: ellipsis !important;
      }
    }
  }

  .address {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1.5rem;
    flex: 1;

    article {
      p {
        display: flex;
        align-items: center;
      }
    }

    h2 {
      margin: 10px 0 10px 0;
      font-size: 14px;
      color: #b8b8b8;
    }
  }

  .service {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    text-align: left;
    padding-top: 1rem;

    div {
      p {
        margin-bottom: 1rem;
      }

      span {
        width: 120px;
        background: var(--primary);
        text-align: center;
      }
    }

    .lastP {
      font-size: 0.8rem;
    }
  }

  .additionalInfo {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1rem;
    flex: 1;

    p {
      display: flex;
      align-items: center;
      text-align: left;
      width: 100%;
      font-size: 14px;
      line-height: 22px;

      img {
        margin-right: 5px;
        width: 15px;
        height: 15px;
      }
    }
  }

  .options {
    height: 100%;
    display: flex;
    justify-content: space-between;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1rem;
    margin-left: 1rem;

    .buttons {
      margin-top: 1rem;
    }

    button {
      width: 226px;
      height: 42px;
      margin-bottom: 10px;
      background: #2e2d2d !important;
      color: white;
      font-size: 14px;
      color: #ebebeb;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export const CardHeader = styled.header`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;

  .favoriteIcon {
    position: absolute;
    top: -2.2rem;
    left: -0.2rem;
    background: none;
  }

  .protocol {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: var(--black-300);
    width: 280px;
    border-radius: 4px;

    .infoColumn {
      width: 280px;
      height: 100%;
      margin-left: 10px;
      padding: 1rem;

      .infoColumnHeader {
        display: flex;
        flex-direction: row;
        text-align: left;
        align-items: center;

        p {
          font-size: 14px;
          line-height: 22px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }

        img {
          margin-right: 10px;
        }
      }
    }
  }

  strong {
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
  }

  img {
    width: 4rem;
    height: 4rem;
    background: var(--black-100);
    border-radius: 4px;
  }
`;

export const PinButton = styled.button`
  border-radius: 4px;
  background: var(--black-400);
  padding: 0.4rem;
  position: absolute;
  top: -1.3rem;
  left: 0.6rem;
  height: 35px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: var(--primary);
      fill: transparent;
    }
  }

  &.active {
    svg {
      path {
        fill: var(--primary);
        stroke: var(--primary);
      }
    }
  }

  transition: 0.4s background;

  &:hover {
    background-color: var(--black-300);
  }
`;

export const ProtocolContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--black-400);
  width: 280px;
  min-height: 360px;
  border-radius: 4px;
  padding: 0.8rem;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;

    p {
      font-family: Inter;
      color: var(--grey-100);
    }

    span {
      font-family: Inter;
    }

    > div:last-child {
      margin-left: 0.5rem;
    }

    .occurrence-icon {
      background-color: var(--black-100);
      border-radius: 4px;
      padding: 0.85rem;
    }
  }

  .protocol-id-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &.skeleton {
      margin-top: 1rem;
    }

    span {
      text-transform: uppercase;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 35px;
      height: 35px;

      background-color: var(--black-200);

      padding: 0.5rem;

      border-radius: 4px;

      transition: 0.4s background;

      &:hover {
        background-color: var(--black-100);
      }
    }

    svg {
      path {
        stroke: var(--grey-100);
      }
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-start !important;

  article {
    margin-top: 1.3rem;
  }

  button {
    width: 100% !important;
    align-self: stretch;
    height: 42px;
    background-color: var(--black-400) !important;
    margin-bottom: 10px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    transition: 0.4s background;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background-color: var(--black-100) !important;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  width: 20%;
  padding: 1.1rem 0rem 0rem;
  border-top: 1px solid rgba(82, 82, 82, 0.32);

  button {
    width: 100%;

    padding: 1.5rem 0rem;

    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 600;

    transition: brightness 0.4s;

    &:hover {
      filter: brightness(70%);
    }

    &:first-of-type {
      width: 56.93%;

      font-weight: 500;
      margin-right: 1rem;

      &:hover {
        background-color: lighten(#2e2d2d, 5%);
      }
    }
  }

  display: none;
  visibility: collapse;

  @media (max-width: 1366px) {
    display: flex;
    flex-direction: row !important;
    visibility: visible;
    margin-top: 1.3rem;

    > div {
      width: 100%;
    }

    article {
      display: flex;
      flex-direction: row;
      margin-top: 0.5rem;
    }

    button {
      width: 100% !important;
      align-self: stretch !important;
      height: 36px;
      background-color: var(--black-400) !important;
      margin-right: 0.5rem;
      color: white;
      font-size: 13px;
      font-weight: 500;
      transition: 0.4s background;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        background-color: var(--black-100) !important;
      }
    }
  }
`;
